import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface H1Props extends ComponentPropsWithRef<"h1"> {
  blockPath: string;
  styles?: Record<string, StyleValue>;
  text: string;
}

export const H1 = forwardRef<HTMLHeadingElement, H1Props>(
  ({ text, blockPath, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <h1
        ref={ref}
        className={classNames(
          "wb-text-h1-color wb-text-h1 wb-font-h1 wb-leading-h1 wb-tracking-h1 wb-whitespace-pre-wrap",
          className,
        )}
        style={inlineStyles}
        data-testid="builder-heading"
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </h1>
    );
  },
);

H1.displayName = "H1";
